import { useEffect, useMemo, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link } from "react-router-dom";
import Select from "react-select";
import TaskSkeleton from "./TaskSkeleton";
import { canEdit } from "../utils/permissions";

export default function Amc_list() {
  const { http, user } = AuthUser();
  const allowEdit = canEdit(user);
  const [tasks, setTasks] = useState([]);
  const [date, setDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [remark, setRemark] = useState(null);
  const [departments, setdepartments] = useState([]);
  const [company, setCompany] = useState([]);
  const [reminderCompanies, setReminderCompanies] = useState([]);
  const [selectCompany, setselectedCompany] = useState("");
  const [currentStatus, setCurrentStatus] = useState(null);
  const [loginUser, setloginUser] = useState(user.department_id);
  const [startDate, setstartDate] = useState("");
  const [selectResolve, setselectedResolve] = useState("No");
  const [endDate, setendDate] = useState("");
  const [editUser, setEditUser] = useState({});

  const normalizeCompanyName = (name) =>
    String(name || "")
      .replace(/^\(I\)\s*/i, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

  const truncateText = (text, maxLen = 18) => {
    const value = String(text || "").trim();
    if (value.length <= maxLen) return value;
    return `${value.slice(0, maxLen)}...`;
  };

  const reminderCompanySet = useMemo(() => {
    const set = new Set();
    (reminderCompanies || []).forEach((row) => {
      const key = normalizeCompanyName(row?.company_name || row);
      if (key) set.add(key);
    });
    return set;
  }, [reminderCompanies]);

  const isReminderCompany = (companyName) => {
    const key = normalizeCompanyName(companyName);
    return !!key && reminderCompanySet.has(key);
  };

  useEffect(() => {
    fetchTaskDetails(selectCompany, startDate, endDate, selectResolve);
  }, [selectCompany, startDate, endDate, selectResolve]);

  useEffect(() => {
    http
      .get(`/unique_reminder_company`, {
        params: { type: "AMC- COMPUTER" },
      })
      .then((res) => {
        setReminderCompanies(Array.isArray(res.data.data) ? res.data.data : []);
      })
      .catch(() => {
        setReminderCompanies([]);
      });
  }, []);

  const fetchTaskDetails = (
    companyset = "",
    start = "",
    end = "",
    resolve = "No"
  ) => {
    setIsLoading(true);
    let endpoint = `/get_amc?login_user=${user.id}&company=${companyset}&startdate=${start}&enddate=${end}&resolve=${resolve}`;

    http
      .get(endpoint)
      .then((res) => {
        setIsLoading(false);
        if (Array.isArray(res.data.users)) {
          setTasks(res.data.users);
        } else {
          setIsLoading(false);
          console.error("API response is not an array");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });

    http.get(`/unique_company?login_user=${user.id}`).then((res) => {
      setCompany(res.data.data);
    });
  };

  const deleteTask = async (taskId) => {
    await http
      .delete(`/amc_del/${taskId}`)
      .then((response) => {
        toast.success("AMC Deleted successfully !");
        fetchTaskDetails();
      })
      .catch((err) => {
        console.error("Error deleting task", err);
      });
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "Completed":
        return <span className="badge bg-success font-size-13">Completed</span>;
      case "Finished":
        return <span className="badge bg-primary font-size-13">Finished</span>;
      case "Pending":
        return <span className="badge bg-warning font-size-13">Pending</span>;
      case "Delayed":
        return <span className="badge bg-danger font-size-13">Delayed</span>;
      case "Delayed Completed":
        return (
          <span className="badge bg-danger font-size-13">
            Delayed Completed
          </span>
        );
      case "Progress":
        return (
          <span className="badge bg-secondary font-size-13">Progress</span>
        );
      default:
        return null; // Handle any other cases or leave it as null if not needed
    }
  };

  const [showModalRevise, setShowModalRevise] = useState(false);
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [descriptionToView, setDescriptionToView] = useState("");
  const [showContactNoteModal, setShowContactNoteModal] = useState(false);
  const [contactNoteMode, setContactNoteMode] = useState("add");
  const [contactNoteTicket, setContactNoteTicket] = useState(null);
  const [contactNoteText, setContactNoteText] = useState("");
  const [isSavingContactNote, setIsSavingContactNote] = useState(false);
  const [revealedPhoneId, setRevealedPhoneId] = useState(null);
  const [revealedEmailId, setRevealedEmailId] = useState(null);
  const [ModalId, setModalId] = useState(false);
  const [billtype, setBilltype] = useState();
  const [billvalue, setBillvalue] = useState();
  const [billTypes, setBillTypes] = useState();
  const [resolved, setResolved] = useState();

  const [formData, setFormData] = useState({
    bill: "",
    bill_value: "",
    bill_type: "",
    is_resolve: "",
    time_tacken: "",
    add1: "200",
    company: ""
  });



  const openModalRevise = (user) => {
    setShowModalRevise(true);
    setFormData({
      bill: user.bill || "",
      bill_value: user.bill_value || "",
      bill_type: user.bill_type || "",
      is_resolve: user.is_resolve || "",
      time_tacken: user.ext1 || "",
      add1: user.add1 || "200",
      company: user.company || "",
      name: user.name || "",
    });
    setEditUser(user);
  }

  const closeModal = () => {
    setShowModalRevise(false);
  };

  const openDescriptionModal = (text) => {
    setDescriptionToView(text || "");
    setShowDescriptionModal(true);
  };

  const closeDescriptionModal = () => {
    setShowDescriptionModal(false);
    setDescriptionToView("");
  };

  const copyDescription = (text) => {
    const str = text || "";
    if (!str) {
      toast("Nothing to copy");
      return;
    }
    navigator.clipboard.writeText(str).then(
      () => toast.success("Description copied to clipboard"),
      () => toast.error("Failed to copy")
    );
  };



  const handleChangeModal = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    console.log(formData);
    e.preventDefault();
    try {
      http.put(`/revise_bill/${editUser.id}`, formData).then((res) => {
        toast.success("Bills updated successfully !");
        fetchTaskDetails();
        closeModal();
      });
    } catch (error) {
      console.error("Error adding task:", error.response.data);
    }
  };

  const sendConfirm = async (userId, id) => {
    await http
      .post(`/send_confirm_jc_amc/${userId}/${id}`)
      .then((response) => {
        toast.success("Confirmation Email/SMS sent");
        // setTasks(response.data.data);
        fetchTaskDetails();
      })
      .catch((err) => {
        console.error("Error deleting task", err);
      });
  };

  const companyOptions = useMemo(() => {
    const seen = new Set();
    const opts = [{ value: "", label: "All Company" }];
    (company || []).forEach((depart) => {
      const name = String(depart?.company || "").trim();
      if (!name) return;
      const key = name.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      opts.push({ value: name, label: name });
    });
    return opts;
  }, [company]);

  const selectedCompanyOption =
    companyOptions.find((o) => o.value === selectCompany) || companyOptions[0];

  const handleChangeResolve = async (event) => {


    setselectedResolve(event.target.value);
  };

  const handleChangeStartDate = async (event) => {
    setstartDate(event.target.value);
  };

  const handleChangeEndDate = async (event) => {
    setendDate(event.target.value);
  };

  const toggleContacted = async (taskuser) => {
    const isContacted = !!taskuser.is_contacted;
    if (isContacted) {
      const ok = window.confirm(
        "This ticket is already marked as contacted.\nClick OK to clear the contacted mark."
      );
      if (!ok) return;
      try {
        const res = await http.put(`/amc_contacted/${taskuser.id}`);
        const updated = res.data.data;
        setTasks((prev) =>
          prev.map((t) =>
            t.id === taskuser.id
              ? {
                  ...t,
                  is_contacted: updated.is_contacted,
                  contacted_at: updated.contacted_at,
                  contacted_note: updated.contacted_note,
                }
              : t
          )
        );
        toast.success("Contacted mark cleared");
      } catch (err) {
        console.error("Error updating contacted status", err);
        toast.error("Failed to update contacted status");
      }
      return;
    }

    setContactNoteTicket(taskuser);
    setContactNoteText("");
    setContactNoteMode("add");
    setShowContactNoteModal(true);
  };

  const submitContactNote = async (e) => {
    e.preventDefault();
    const note = contactNoteText.trim();
    if (!note) {
      toast.error("Please enter a note");
      return;
    }
    if (!contactNoteTicket) return;
    setIsSavingContactNote(true);
    try {
      const res = await http.put(`/amc_contacted/${contactNoteTicket.id}`, { note });
      const updated = res.data.data;
      setTasks((prev) =>
        prev.map((t) =>
          t.id === contactNoteTicket.id
            ? {
                ...t,
                is_contacted: updated.is_contacted,
                contacted_at: updated.contacted_at,
                contacted_note: updated.contacted_note,
              }
            : t
        )
      );
      toast.success("Marked as contacted");
      setShowContactNoteModal(false);
      setContactNoteTicket(null);
      setContactNoteText("");
    } catch (err) {
      console.error("Error updating contacted status", err);
      toast.error(err.response?.data?.message || "Failed to update contacted status");
    } finally {
      setIsSavingContactNote(false);
    }
  };

  const openContactedNote = (taskuser) => {
    setContactNoteTicket(taskuser);
    setContactNoteText(taskuser.contacted_note || "");
    setContactNoteMode("view");
    setShowContactNoteModal(true);
  };

  const closeContactNoteModal = () => {
    setShowContactNoteModal(false);
    setContactNoteTicket(null);
    setContactNoteText("");
    setContactNoteMode("add");
  };

  const contactDelayMinutes = (taskuser) => {
    if (!taskuser.is_contacted || !taskuser.contacted_at || !taskuser.created_at) {
      return null;
    }
    return moment(taskuser.contacted_at).diff(moment(taskuser.created_at), "minutes");
  };

  return (
    <>
      <Toaster />
      {/* Description View Modal */}
      {showDescriptionModal && (
        <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Description</h5>
                <button type="button" className="btn-close" onClick={closeDescriptionModal} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="p-3 bg-light rounded" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", minHeight: "80px" }}>
                  {descriptionToView || <span className="text-muted">No description</span>}
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => copyDescription(descriptionToView)}>
                  <i className="fas fa-copy me-1"></i> Copy
                </button>
                <button type="button" className="btn btn-secondary" onClick={closeDescriptionModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showContactNoteModal && (
        <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <form className="modal-content" onSubmit={submitContactNote}>
              <div className="modal-header">
                <h5 className="modal-title">
                  {contactNoteMode === "view" ? "Contact Note" : "Mark Contacted"}
                </h5>
                <button type="button" className="btn-close" onClick={closeContactNoteModal} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                {contactNoteTicket && (
                  <p className="text-muted mb-2" style={{ fontSize: "13px" }}>
                    AC{contactNoteTicket.id} — {contactNoteTicket.name}
                  </p>
                )}
                {contactNoteMode === "view" ? (
                  <>
                    <div className="mb-2" style={{ fontSize: "12px", color: "#166534" }}>
                      {contactNoteTicket?.contacted_at
                        ? moment(contactNoteTicket.contacted_at).format("DD-MM-YY hh:mm A")
                        : ""}
                    </div>
                    <div className="p-3 bg-light rounded" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", minHeight: "80px" }}>
                      {contactNoteText || <span className="text-muted">No note</span>}
                    </div>
                  </>
                ) : (
                  <>
                    <label className="form-label">Note <span className="text-danger">*</span></label>
                    <textarea
                      className="form-control"
                      rows="4"
                      value={contactNoteText}
                      onChange={(e) => setContactNoteText(e.target.value)}
                      placeholder="Type contact note..."
                      required
                      autoFocus
                    />
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary btn-sm" onClick={closeContactNoteModal}>
                  {contactNoteMode === "view" ? "Close" : "Cancel"}
                </button>
                {contactNoteMode !== "view" && (
                  <button type="submit" className="btn btn-success btn-sm" disabled={isSavingContactNote}>
                    {isSavingContactNote ? "Saving..." : "Save & Mark Contacted"}
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      )}

      {showModalRevise && (
        <div className="modal" tabindex="-1" style={{ display: "block" }}>
          <form onSubmit={handleSubmit}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Revision Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                  <div className="form-group mt-3">
                    <label className="text-primary p-2 mb-1">Name : {formData.company}</label>
                    <select
                      className="form-control"
                      name="company"
                      value={formData.company}
                      onChange={handleChangeModal}
                      required
                    >
                      <option value="">All Company</option>
                      {company.map((depart) => (
                        <option key={depart.id} value={depart.company}>
                          {depart.company}
                        </option>
                      ))}
                    </select>
                  </div>
                  <hr />
                  <div className="form-group mt-3">
                    <label>Type Bills</label>
                    <select
                      className="form-control"
                      name="bill"
                      value={formData.bill}
                      onChange={handleChangeModal}
                      required
                    >
                      <option value="">Select Any</option>
                      <option value="AMC">AMC</option>
                      <option value="NO BILL">NO BILL</option>
                      <option value="INVOICED">INVOICED</option>
                      <option value="INV PENDING">INV PENDING</option>
                    </select>
                  </div>

                  <div className="form-group mt-3">
                    <label>Bill Value</label>
                    <input
                      type="text"
                      name="bill_value"
                      className="form-control"
                      value={formData.bill_value}
                      onChange={handleChangeModal}
                    ></input>
                  </div>
                  <hr />

                  <div className="form-group mt-3">
                    <label>Resolve</label>
                    <select
                      className="form-control"
                      name="is_resolve"
                      value={formData.is_resolve}
                      onChange={handleChangeModal}
                      required
                    >
                      <option value="">Select Any</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  <div className="form-group mt-3">
                    <label>Visit Nature</label>
                    <select
                      className="form-control"
                      name="bill_type"
                      value={formData.bill_type}
                      onChange={handleChangeModal}
                    >
                      <option value="">Select Any</option>
                      <option value="Online">Online</option>
                      <option value="Offline">Offline</option>
                    </select>
                  </div>

                  <div className="form-group mt-3">
                    <label>Time Tacken</label>
                    <select
                      className="form-control"
                      name="time_tacken"
                      value={formData.time_tacken}
                      onChange={handleChangeModal}
                    >
                      <option value="">Select Any</option>
                      <option value="1">1 Hr</option>
                      <option value="2">2 Hr</option>
                      <option value="3">3 Hr</option>
                      <option value="4">4 Hr</option>
                      <option value="5">5 Hr</option>
                      <option value="6">6 Hr</option>
                      <option value="7">7 Hr</option>
                      <option value="8">8 Hr</option>
                      <option value="9">9 Hr</option>
                      <option value="10">10 Hr</option>
                    </select>
                  </div>
                  <div className="form-group mt-3">
                    <label>Hourly Rate</label>
                    <select
                      className="form-control"
                      name="add1"
                      value={formData.add1}
                      onChange={handleChangeModal}
                    >
                      <option value="">Select Any</option>
                      <option value="100">Rs 100</option>
                      <option value="200">Rs 200</option>
                      <option value="300">Rs 300</option>
                      <option value="400">Rs 400</option>
                      <option value="500">Rs 500</option>
                      <option value="600">Rs 600</option>
                      <option value="700">Rs 700</option>
                      <option value="800">Rs 800</option>
                    </select>
                  </div>

                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn-sm btn btn-success"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      )}
      <div className="container-fluid mt-2 px-3">
        <style>{`
          .amc-table {
            font-size: 13px;
            margin-bottom: 0;
          }
          .amc-table th,
          .amc-table td {
            vertical-align: middle !important;
            white-space: nowrap;
            padding: 8px 10px;
          }
          .amc-table th {
            font-size: 12px;
            font-weight: 700;
            position: sticky;
            top: 0;
            z-index: 2;
          }
          .amc-table .name-cell,
          .amc-table .company-cell {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .amc-table .name-cell {
            max-width: 140px;
          }
          .amc-table .company-cell {
            max-width: 280px;
            min-width: 220px;
          }
          .amc-match-badge {
            display: inline-block;
            background: #16a34a;
            color: #fff;
            font-size: 10px;
            font-weight: 700;
            line-height: 1;
            padding: 3px 5px;
            border-radius: 4px;
            margin-right: 5px;
            vertical-align: middle;
          }
          .amc-company-match {
            color: #15803d;
          }
          .amc-icon-btn {
            border: 1px solid #cbd5e1;
            background: #fff;
            color: #0d6efd;
            width: 28px;
            height: 28px;
            border-radius: 6px;
            padding: 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
          }
          .amc-reveal {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 12px;
          }
          .amc-cstatus {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            font-size: 11px;
            font-weight: 700;
            border-radius: 999px;
            padding: 3px 8px;
            white-space: nowrap;
          }
          .amc-cstatus.ok {
            background: #dcfce7;
            color: #166534;
          }
          .amc-cstatus.late {
            background: #fee2e2;
            color: #b91c1c;
          }
          .amc-table .desc-cell {
            min-width: 220px;
            max-width: 260px;
          }
          .amc-table .desc-wrap {
            display: flex;
            align-items: center;
            gap: 8px;
            width: 100%;
          }
          .amc-table .desc-text {
            flex: 1 1 auto;
            min-width: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.4;
          }
          .amc-table .desc-actions {
            display: flex;
            align-items: center;
            gap: 4px;
            flex: 0 0 auto;
          }
          .amc-table .desc-actions .btn {
            width: 26px;
            height: 26px;
            padding: 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            line-height: 1;
          }
          .amc-table .assigned-cell {
            white-space: nowrap;
            min-width: 120px;
          }
          .amc-table .assigned-cell .badge {
            white-space: nowrap;
            display: inline-block;
            max-width: 140px;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
          }
          .amc-table .assigned-cell .badge-unassigned {
            background: #dc2626 !important;
            color: #fff !important;
            border: 1px solid #b91c1c;
            font-weight: 700;
            padding: 5px 10px;
          }
          .amc-table .created-cell {
            white-space: nowrap;
          }
          .amc-table tr.contacted-row {
            background-color: #ecfdf5 !important;
          }
          .amc-contacted-btn {
            border: 1px solid #86efac;
            background: #fff;
            color: #166534;
            border-radius: 999px;
            padding: 3px 10px;
            font-size: 11px;
            font-weight: 600;
            white-space: nowrap;
            line-height: 1.3;
          }
          .amc-contacted-btn:hover {
            background: #f0fdf4;
          }
          .amc-contacted-done {
            display: inline-flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 2px;
            border: none;
            background: transparent;
            padding: 0;
            cursor: pointer;
            text-align: left;
          }
          .amc-contacted-done .done-label {
            background: #16a34a;
            color: #fff;
            border-radius: 999px;
            padding: 3px 10px;
            font-size: 11px;
            font-weight: 700;
            white-space: nowrap;
          }
          .amc-contacted-done .done-time {
            color: #15803d;
            font-size: 10px;
            font-weight: 600;
            padding-left: 4px;
          }
        `}</style>
        <h1 style={{ fontSize: "1.4rem", marginBottom: "12px" }}>Tickets</h1>

        <div className="d-flex align-items-center flex-wrap gap-2 mb-3">
          <div style={{ minWidth: "260px", width: "280px" }}>
            <Select
              options={companyOptions}
              value={selectedCompanyOption}
              onChange={(opt) => setselectedCompany(opt ? opt.value : "")}
              isSearchable
              placeholder="Search company..."
              noOptionsMessage={() => "No company found"}
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: 31,
                  height: 31,
                  fontSize: 13,
                }),
                valueContainer: (base) => ({
                  ...base,
                  padding: "0 8px",
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  height: 31,
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 20,
                  fontSize: 13,
                }),
              }}
            />
          </div>

          <select
            onChange={handleChangeResolve}
            className="form-control form-control-sm"
            style={{ width: "140px" }}
          >
            <option value="">Resolve</option>
            <option value="">All</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>

          <input
            name="start_date"
            onChange={handleChangeStartDate}
            className="form-control form-control-sm"
            type="date"
            style={{ width: "150px" }}
          />

          <input
            name="end_date"
            onChange={handleChangeEndDate}
            className="form-control form-control-sm"
            type="date"
            style={{ width: "150px" }}
          />
        </div>

        <div className="table-responsive" style={{ maxHeight: "70vh", overflow: "auto", border: "1px solid #e5e7eb", borderRadius: "8px" }}>
          {isLoading ? (
            <TaskSkeleton />
          ) : (
            <table className="table table-hover amc-table">
              <thead className="table-primary">
                <tr>
                  <th>No</th>
                  <th>T-Number</th>
                  <th>Created</th>
                  <th>Name</th>
                  <th>Company</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Priority</th>
                  <th>Description</th>
                  <th>Assigned</th>
                  <th>Contacted</th>
                  <th>C-status</th>
                  <th>Bills</th>
                  <th>Resolve</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>T-taken</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((taskuser, index) => (
                  <tr
                    key={index}
                    className={taskuser.is_contacted ? "contacted-row" : ""}
                  >
                    <td>{index + 1}</td>
                    <td>AC{taskuser.id}</td>
                    <td className="created-cell">{moment(taskuser.created_at).format("DD-MM-YY hh:mm A")}</td>
                    <td className="name-cell" title={taskuser.name || ""}>
                      {truncateText(taskuser.name, 20)}
                    </td>
                    <td className="company-cell" title={taskuser.company || ""}>
                      {isReminderCompany(taskuser.company) ? (
                        <b className="amc-company-match">
                          <span
                            className="amc-match-badge"
                            title="Matched in jc_antireminders (AMC- COMPUTER)"
                          >
                            AMC
                          </span>
                          {truncateText(taskuser.company, 36)}
                        </b>
                      ) : (
                        <b>{truncateText(taskuser.company, 36)}</b>
                      )}
                    </td>
                    <td>
                      {revealedPhoneId === taskuser.id ? (
                        <span className="amc-reveal">
                          <button
                            type="button"
                            className="amc-icon-btn"
                            title="Hide phone"
                            onClick={() => setRevealedPhoneId(null)}
                          >
                            <i className="fas fa-phone"></i>
                          </button>
                          {taskuser.phone || "-"}
                        </span>
                      ) : (
                        <button
                          type="button"
                          className="amc-icon-btn"
                          title="Show phone"
                          onClick={() => setRevealedPhoneId(taskuser.id)}
                          disabled={!taskuser.phone}
                        >
                          <i className="fas fa-phone"></i>
                        </button>
                      )}
                    </td>
                    <td>
                      {revealedEmailId === taskuser.id ? (
                        <span className="amc-reveal">
                          <button
                            type="button"
                            className="amc-icon-btn"
                            title="Hide email"
                            onClick={() => setRevealedEmailId(null)}
                          >
                            <i className="fas fa-envelope"></i>
                          </button>
                          {taskuser.email || "-"}
                        </span>
                      ) : (
                        <button
                          type="button"
                          className="amc-icon-btn"
                          title="Show email"
                          onClick={() => setRevealedEmailId(taskuser.id)}
                          disabled={!taskuser.email}
                        >
                          <i className="fas fa-envelope"></i>
                        </button>
                      )}
                    </td>
                    <td>{taskuser.priority}</td>
                    <td className="desc-cell">
                      <div className="desc-wrap">
                        <span
                          className="desc-text"
                          title={taskuser.description || ""}
                        >
                          {taskuser.description || "—"}
                        </span>
                        <span className="desc-actions">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => openDescriptionModal(taskuser.description)}
                            title="View full description"
                          >
                            <i className="fas fa-eye"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => copyDescription(taskuser.description)}
                            title="Copy description"
                          >
                            <i className="fas fa-copy"></i>
                          </button>
                        </span>
                      </div>
                    </td>
                    <td className="assigned-cell">
                      {taskuser.tasks.length > 0 ? (
                        <span
                          className="badge bg-success"
                          title={taskuser.tasks.map((t) => t.assignee?.name).filter(Boolean).join(", ")}
                        >
                          ✅ {taskuser.tasks.map((task) => task.assignee?.name).filter(Boolean).join(", ")}
                        </span>
                      ) : (
                        <span className="badge badge-unassigned">Unassigned</span>
                      )}
                    </td>
                    <td>
                      {taskuser.is_contacted ? (
                        <div className="amc-contacted-done">
                          {allowEdit ? (
                          <button
                            type="button"
                            className="done-label"
                            onClick={() => toggleContacted(taskuser)}
                            title="Click to clear contacted mark"
                            style={{ border: "none", cursor: "pointer" }}
                          >
                            ✓ Contacted
                          </button>
                          ) : (
                            <span className="done-label">✓ Contacted</span>
                          )}
                          <button
                            type="button"
                            className="done-time"
                            onClick={() => openContactedNote(taskuser)}
                            title="View contact note"
                            style={{ border: "none", background: "transparent", cursor: "pointer", padding: 0 }}
                          >
                            {taskuser.contacted_at
                              ? moment(taskuser.contacted_at).format("DD-MM-YY hh:mm A")
                              : ""}
                            {taskuser.contacted_note ? " 📝" : ""}
                          </button>
                        </div>
                      ) : allowEdit ? (
                        <button
                          type="button"
                          className="amc-contacted-btn"
                          onClick={() => toggleContacted(taskuser)}
                          title="Mark as contacted"
                        >
                          Mark Contacted
                        </button>
                      ) : (
                        <span className="text-muted">—</span>
                      )}
                    </td>
                    <td>
                      {(() => {
                        const mins = contactDelayMinutes(taskuser);
                        if (mins === null) return <span className="text-muted">-</span>;
                        const late = mins > 30;
                        return (
                          <span
                            className={`amc-cstatus ${late ? "late" : "ok"}`}
                            title={`${mins} min from created to contacted`}
                          >
                            {late ? "⚠" : "✓"} {mins}m
                          </span>
                        );
                      })()}
                    </td>
                    <td className="text-primary">
                      {taskuser.bill}-{taskuser.bill_value}
                    </td>
                    <td className="text-primary">
                      <b>{taskuser.is_resolve}</b>
                    </td>
                    <td className="text-primary">{taskuser.bill_type}</td>
                    <td>
                      <b>{getStatusBadge(taskuser.tasks[0]?.status)}</b>
                    </td>
                    <td>
                      <b>{taskuser.ext1}</b>
                    </td>
                    <td>
                      <div className="d-flex align-items-center gap-1">
                        {allowEdit && (
                        <a
                          href={`/jobcart/assign_amc/${taskuser.id}`}
                          className="btn btn-sm btn-outline-primary"
                          style={{ padding: "2px 6px", fontSize: "11px" }}
                        >
                          Assign
                        </a>
                        )}
                        {allowEdit && (
                        <a
                          href="#"
                          className="btn btn-sm btn-outline-warning"
                          style={{ padding: "2px 6px", fontSize: "11px" }}
                          onClick={(e) => {
                            e.preventDefault();
                            openModalRevise(taskuser);
                          }}
                          title="Bills"
                        >
                          💶
                        </a>
                        )}
                        {allowEdit && user.department_id == 1 && (
                          <button
                            className="btn btn-sm btn-outline-danger"
                            style={{ padding: "2px 6px", fontSize: "11px" }}
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Are you sure you want to delete this Task?"
                                )
                              ) {
                                deleteTask(taskuser.id);
                              }
                            }}
                            title="Delete"
                          >
                            ❌
                          </button>
                        )}
                        {allowEdit && (
                        <button
                          className="btn btn-sm btn-outline-secondary"
                          style={{ padding: "2px 6px", fontSize: "11px" }}
                          onClick={() => {
                            if (
                              window.confirm(
                                "Are you sure you want send the emails?"
                              )
                            ) {
                              sendConfirm(taskuser.email, taskuser.id);
                            }
                          }}
                          title="Send Email"
                        >
                          📩
                        </button>
                        )}
                        {taskuser.mail_status == 1 ? "✅" : ""}
                        {!allowEdit && <span className="text-muted">View only</span>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
